module.exports = __webpack_public_path__ + "img/CS-ProfiNew_Overview-DA8_1.ecadcfe6.jpg";